export default {
  async showSnackbar({ commit }, message) {
    console.log("🚀 ~ showSnackbar ~ message:", message)
    commit("setSnackbar", { text: message, enabled: true });
  },
  
};
